import { alpha, Box, styled } from '@mui/material';

export const ExportButton = styled(Box, {
    shouldForwardProp: prop => prop !== 'sideBar',
})<{ sideBar: boolean; disabled?: boolean }>(({ theme, sideBar, disabled }) => {
    const disabledColor = theme.palette.mode === 'dark' ? theme.custom.c5 : theme.custom.c4;

    return [
        {
            userSelect: 'none',
            justifyContent: 'center',
            display: 'flex',
            cursor: disabled ? 'not-allowed' : 'pointer',
            color: disabled ? disabledColor : 'primary.light',
            alignItems: 'center',
            padding: '8px 7px',
            borderRadius: '8px',
            gap: '16px',
            width: sideBar ? 'auto' : '40px',
            [theme.breakpoints.down('lg')]: {
                width: sideBar ? 'auto' : '36px',
            },
            '& svg': {
                fill: disabled ? disabledColor : theme.palette.mode === 'dark' ? theme.custom.c1 : theme.custom.c22,
            },
            '& .MuiTypography-root': {
                color: disabled ? disabledColor : 'inherit',
            },
        },
        sideBar && {
            justifyContent: 'flex-start',
            ...(!disabled && {
                '&:hover': {
                    background:
                        theme.palette.mode === 'dark'
                            ? alpha(theme.palette.secondary.light, 0.04)
                            : alpha(theme.palette.secondary.main, 0.1),
                    '& svg': {
                        color: theme.palette.secondary.main,
                        fill: theme.palette.secondary.main,
                    },
                },
            }),
        },
    ];
});
